import type { MailboxInfo } from "owa-client-types";
import { getAccountScopeUserSettings } from "../selectors/getAccountScopeUserSettings";

export default function getHasArchive(mailboxInfo: MailboxInfo): boolean | undefined {
    return getAccountScopeUserSettings(mailboxInfo).SessionSettings?.HasArchive;
}
